import React from 'react';

const TextEditor = (props) => {
  return (
    <textarea className="form-control" {...props} ></textarea>
  );
}

export default TextEditor